import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

import { getAllSources } from '@/sources/registry';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

/**
 * Data-driven source picker — renders the registered sources.
 * Adding a source = adding a folder under `src/sources/`; this component
 * never needs to change.
 */
export function SourcePicker() {
  const sources = getAllSources();
  const navigate = useNavigate();
  const location = useLocation();

  const currentMatch = location.pathname.match(/^\/source\/([^/]+)/);
  const currentId = currentMatch?.[1];
  const current = currentId ? sources.find((s) => s.id === currentId) : undefined;

  const label = current ? current.name : sources.length > 0 ? 'Pick a source' : 'No sources';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          <span>{label}</span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel>Sources</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {sources.length === 0 ? (
          <DropdownMenuItem disabled>No sources registered</DropdownMenuItem>
        ) : (
          sources.map((source) => (
            <DropdownMenuItem
              key={source.id}
              onSelect={() => navigate(`/source/${source.id}`)}
            >
              {source.name}
            </DropdownMenuItem>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
